export { ContentAfterRecordCheck } from "./ContentAfterRecordCheck";
export type { IContentAfterRecordCheckProps } from "./ContentAfterRecordCheck";
